import { Sparkles, Repeat, Layers, ShieldCheck } from "lucide-react";
import { useT } from "@/i18n/LanguageContext";

const ICONS = [Sparkles, Repeat, Layers, ShieldCheck];

export const About = () => {
  const { t } = useT();
  const features = t("about.features") || [];
  return (
    <section id="about" data-testid="about-section" className="section bg-[#0a0a0a]">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-16">
          <div className="md:col-span-5">
            <div className="eyebrow mb-4 gold-text">{t("about.eyebrow")}</div>
            <h2 className="font-display font-black text-4xl md:text-5xl lg:text-6xl tracking-tighter leading-[1]">
              {t("about.title_l1")} <br />
              {t("about.title_l2")} <br />
              <span className="holo-text">{t("about.title_l3")}</span>
            </h2>
          </div>
          <div className="md:col-span-7 md:pt-12">
            <p className="text-zinc-300 text-base md:text-lg leading-relaxed">
              {t("about.body")}
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {features.map((f, idx) => {
            const Icon = ICONS[idx % ICONS.length];
            return (
              <div key={f.title || idx} data-testid={`feature-${idx}`} className="tile">
                <div className="w-12 h-12 rounded-xl bg-[#1a1a1a] border border-white/10 flex items-center justify-center mb-5">
                  <Icon className="text-[#FFCC51]" size={22} />
                </div>
                <h3 className="font-display font-bold text-xl text-white mb-2">{f.title}</h3>
                <p className="text-sm text-zinc-400 leading-relaxed">{f.text}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
